module.exports = __webpack_public_path__ + "img/bachelor-mechatronik-inhalt-aufbau.7010dec0.jpg";